export default __webpack_public_path__ + "static/5-60aa2ab59aa52c705b24080ea8be30b1.jpg";